import axios from 'axios';

async function cancelFileNotification({fileId}) {
	return axios.post(`/api/files/${fileId}/notifications/cancel`);
}

export default cancelFileNotification;
